import React from 'react'
import { Helmet } from 'react-helmet-async'

export default function RefundPolicy() {
  return (
    <>
      <Helmet>
        <title>Refund Policy - A Plus A Driving School</title>
        <meta name="description" content="Refund Policy for A Plus A Driving School. Learn about our cancellation and refund procedures." />
      </Helmet>
      <div className="py-20 bg-background">
        <div className="container mx-auto px-4 max-w-4xl">
          <h1 className="text-4xl md:text-5xl font-heading font-bold text-primary mb-8">
            Refund Policy
          </h1>
          <div className="text-sm text-secondary-text mb-8">
            Last updated: January 2026
          </div>
          <div className="prose prose-lg max-w-none space-y-6 text-secondary-text">
            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                1. Cancellation Before Course Start
              </h2>
              <p>
                If you cancel your enrollment at least 7 days before the scheduled course start date, you will receive a full refund minus a $50 administrative fee.
              </p>
              <p>
                Cancellations made less than 7 days before the course start date will receive a 50% refund.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                2. Cancellation After Course Start
              </h2>
              <p>
                Once the course has begun, refunds are calculated based on the percentage of the course completed:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Less than 25% completed: 75% refund</li>
                <li>25-50% completed: 50% refund</li>
                <li>50-75% completed: 25% refund</li>
                <li>More than 75% completed: No refund</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                3. Medical or Emergency Situations
              </h2>
              <p>
                In cases of documented medical emergencies or other extenuating circumstances, we will work with you to find a suitable solution, which may include:
              </p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Course transfer to a later date</li>
                <li>Partial refund based on circumstances</li>
                <li>Credit toward future courses</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                4. School-Initiated Cancellations
              </h2>
              <p>
                If A Plus A Driving School cancels a course due to insufficient enrollment or other reasons, you will receive a full refund or the option to transfer to another course at no additional charge.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                5. Refund Processing
              </h2>
              <ul className="list-disc pl-6 space-y-2">
                <li>Refund requests must be submitted in writing</li>
                <li>Refunds will be processed within 14 business days</li>
                <li>Refunds will be issued to the original payment method when possible</li>
                <li>Processing fees may apply to certain payment methods</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                6. Non-Refundable Items
              </h2>
              <p>The following items are non-refundable:</p>
              <ul className="list-disc pl-6 space-y-2">
                <li>Administrative fees</li>
                <li>Completed individual lessons</li>
                <li>Road test fees (if test was taken)</li>
                <li>Course materials that have been used</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                7. How to Request a Refund
              </h2>
              <p>To request a refund, please contact us:</p>
              <div className="bg-gray-50 p-4 rounded-lg mt-4">
                <p className="font-semibold">A Plus A Driving School</p>
                <p>10 Wellington Drive, Stafford, VA 22554</p>
                <p>Phone: <a href="tel:540-615-2418" className="text-primary hover:text-accent">540-615-2418</a></p>
                <p>Email: <a href="mailto:aplusavadrivingschool@gmail.com" className="text-primary hover:text-accent">aplusavadrivingschool@gmail.com</a></p>
              </div>
              <p className="mt-4">
                Please include your full name, course enrollment date, and reason for cancellation in your request.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-heading font-bold text-primary mb-4">
                8. Disputes
              </h2>
              <p>
                If you have concerns about a refund decision, please contact us to discuss your situation. We are committed to fair and reasonable resolution of all refund requests.
              </p>
            </section>
          </div>
        </div>
      </div>
    </>
  )
}

